export const UPDATE_BOOKMARK_OPERATION_NAME = 'KnowledgeDiscoveryAdminhubUpdateBookmarkMutation';
export const UpdateBookmarkMutation: '\n\tmutation KnowledgeDiscoveryAdminhubUpdateBookmarkMutation(\n\t\t$cloudId: ID!, $bookmarkAdminhubId: ID!, $keyPhrases: [String!], $url: String!, $title: String!, $description: String, $orgId: String!\n\t) {\n\t\tknowledgeDiscovery {\n\t\t\tupdateBookmark(\n\t\t\t\tinput: {cloudId: $cloudId, bookmarkAdminhubId: $bookmarkAdminhubId, keyPhrases: $keyPhrases, url: $url, title: $title, description: $description, orgId: $orgId}\n\t\t\t) @optIn(to: "KnowledgeDiscovery Update bookmarks in AdminHub") {\n\t\t\t\t... on KnowledgeDiscoveryUpdateAdminhubBookmarkPayload {\n\t\t\t\t\tsuccess\n\t\t\t\t\terrors {\n\t\t\t\t\t\tmessage\n\t\t\t\t\t\textensions {\n\t\t\t\t\t\t\t\t... on KnowledgeDiscoveryBookmarkMutationErrorExtension {\n\t\t\t\t\t\t\t\tbookmarkFailureMetadata {\n\t\t\t\t\t\t\t\t\terrorType\n\t\t\t\t\t\t\t\t\t... on KnowledgeDiscoveryBookmarkCollisionFailureMetadata {\n\t\t\t\t\t\t\t\t\tkeyPhrase\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t... on KnowledgeDiscoveryBookmarkValidationFailureMetadata {\n\t\t\t\t\t\t\t\t\tkeyPhrase\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tadminhubBookmark {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tproperties {\n\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\tdescription\n\t\t\t\t\t\t\tkeyPhrases\n\t\t\t\t\t\t\turl\n\t\t\t\t\t\t}\n        \t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n' = `
	mutation ${UPDATE_BOOKMARK_OPERATION_NAME}(
		$cloudId: ID!, $bookmarkAdminhubId: ID!, $keyPhrases: [String!], $url: String!, $title: String!, $description: String, $orgId: String!
	) {
		knowledgeDiscovery {
			updateBookmark(
				input: {cloudId: $cloudId, bookmarkAdminhubId: $bookmarkAdminhubId, keyPhrases: $keyPhrases, url: $url, title: $title, description: $description, orgId: $orgId}
			) @optIn(to: "KnowledgeDiscovery Update bookmarks in AdminHub") {
				... on KnowledgeDiscoveryUpdateAdminhubBookmarkPayload {
					success
					errors {
						message
						extensions {
								... on KnowledgeDiscoveryBookmarkMutationErrorExtension {
								bookmarkFailureMetadata {
									errorType
									... on KnowledgeDiscoveryBookmarkCollisionFailureMetadata {
									keyPhrase
									}
									... on KnowledgeDiscoveryBookmarkValidationFailureMetadata {
									keyPhrase
									}
								}
							}
						}
					}
					adminhubBookmark {
						id
						properties {
							title
							description
							keyPhrases
							url
						}
        	}
				}
			}
		}
	}
`;
